function getGoogleTagConsent(cookiePreferences) {
  const consent = {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
  };

  if (cookiePreferences.advertising) {
    consent.ad_storage = 'granted';
    consent.ad_user_data = 'granted';
    consent.ad_personalization = 'granted';
  }

  if (cookiePreferences.marketingAndAnalytics) {
    consent.analytics_storage = 'granted';
  }

  return consent;
}

export function updateGoogleTagConsent(cookiePreferences) {
  if (!window.dataLayer) {
    return;
  }

  function gtag() {
    window.dataLayer.push(arguments);
  }

  gtag('consent', 'update', getGoogleTagConsent(cookiePreferences));
}

export const googleTagScript = `
    <script>
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}

      gtag('consent', 'default', ${JSON.stringify(getGoogleTagConsent({}))});
    </script>
    <script async src="https://www.googletagmanager.com/gtag/js?id=${
      process.env.GOOGLE_TAG_IDAGIO_WEBSITE_ALL_COUNTRIES_ID
    }"></script>
    <script>
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${process.env.GOOGLE_TAG_IDAGIO_WEBSITE_ALL_COUNTRIES_ID}');
    </script>
  `;
